import { useSendWhatsAppTemplate } from 'src/modules/shared/messaging/hooks/use-send-whatsapp-template';
import type { WhatsAppTemplateModalDisplayProps } from '../../../../types/templates/template-modal.types';
import { WhatsAppTemplateModalContent } from './template-modal-content';

/** Binds standalone sends without imposing CRM context on existing callers. */
export const StandaloneWhatsAppTemplateModal = (
  props: WhatsAppTemplateModalDisplayProps
) => {
  const { sendTemplate, isPending } = useSendWhatsAppTemplate();
  return (
    <WhatsAppTemplateModalContent
      {...props}
      onSendTemplate={sendTemplate}
      isSending={isPending}
    />
  );
};
